
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M15.5 14H14.71L14.43 13.73C15.63 12.33 16.25 10.42 15.91 8.39003C15.44 5.61003 13.12 3.40003 10.33 3.05003C6.54003 2.58003 3.30003 5.38003 3.03003 9.00003H5.05003C5.29003 6.88003 6.97003 5.20003 9.11003 5.02003C11.65 4.80003 14 6.95003 14 9.50003C14 11.99 11.99 14 9.50003 14C9.33003 14 9.17003 13.97 9.00003 13.95V15.97C9.00003 15.97 9.00003 15.97 9.01003 15.98C10.81 16.11 12.48 15.51 13.73 14.43L14 14.71V15.5L18.25 19.75C18.66 20.16 19.33 20.16 19.74 19.75C20.15 19.34 20.15 18.67 19.74 18.26L15.5 14Z' fill='#323232'/><path d='M6.12002 11.17L4.00002 13.29L1.88002 11.17C1.68002 10.97 1.37002 10.97 1.17002 11.17C0.97002 11.37 0.97002 11.68 1.17002 11.88L3.29002 14L1.17002 16.12C0.97002 16.32 0.97002 16.63 1.17002 16.83C1.37002 17.03 1.68002 17.03 1.88002 16.83L4.00002 14.71L6.12002 16.83C6.32002 17.03 6.63002 17.03 6.83002 16.83C7.03002 16.63 7.03002 16.32 6.83002 16.12L4.71002 14L6.83002 11.88C7.03002 11.68 7.03002 11.37 6.83002 11.17C6.63002 10.98 6.32002 10.98 6.12002 11.17Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-search-off`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconSearchOff

    ```js
    <b-new-b-icon-search-off />
    ```
</docs>


